module.exports = __webpack_public_path__ + "assets/img/warrior-name-601fb212.png";